import { Row, Col } from 'antd';
import typesStyles from './utils/ExamTypes';

const alignment = {
  display: 'flex',
  alignItems: 'center'
};

const Symbols = ({ types }) => {
  return (
    <Row gutter={20} className="symbols-wrapper mb-20">
      {
        types.map((type, index) => (
          <Col key={index}>
            <Row gutter={7}>
              {
                !typesStyles[type].icon &&
                <Col style={alignment}>
                  <div className={typesStyles[type].color} />
                </Col>
              }
              {
                typesStyles[type].icon && <div>{typesStyles[type].icon}</div>
              }
              <Col>
                <p className='mb-0'>{typesStyles[type].text}</p>
              </Col>
            </Row>
          </Col>
        ))
      }
    </Row>
  );
};

export default Symbols;